// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BigTabs_wrapper__1cvje"};